/**
 * Copyright IBM Corp. 2022, 2026
 */

import EventTitle from 'components/_page-components/events/event-title'
import RegistrationForm from 'components/_page-components/events/registration-form'
import TopicContent from 'components/_page-components/events/topic-content'
import Agenda from 'components/_page-components/events/agenda'
import Tags from 'components/_page-components/events/tags'
import SpeakerList from 'components/_page-components/events/speaker-list'
import s from './live.module.css'

export default function Live(props) {
	const {
		title,
		partnerLogos,
		tagLine,
		description,
		content,
		agenda,
		speakers,
		tags,
		pending,
		marketoFormId,
		destinationUrl,
		formTitle,
	} = props
	return (
		<div className={s.container}>
			<div className={s.details}>
				<EventTitle
					title={title}
					partnerLogos={partnerLogos}
					tagLine={tagLine}
					type={pending ? 'pending' : 'live'}
				/>
				<div
					className={`g-type-body ${s.description}`}
					dangerouslySetInnerHTML={{ __html: description }}
				/>

				<SpeakerList speakers={speakers} />
				{content && <TopicContent content={content} />}
				{agenda && <Agenda title={agenda.headline} items={agenda.rows} />}
				<Tags tags={tags} />
			</div>

			<RegistrationForm
				{...props}
				formTitle={formTitle}
				marketoFormId={marketoFormId}
				destinationUrl={destinationUrl}
				pending={pending}
			/>
		</div>
	)
}
